export default "__VITE_ASSET__BK7MjBf0__"